// extracted by mini-css-extract-plugin
export default {"box":"ProgressTab_box__HQzAH","active":"ProgressTab_active__VNb6V"};